<template>
    <div class="window-wrapper window-client-check-error-3">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Не удалось отправить письмо по следующим email: {{getRecepients(letter.recepientList)}}.<br> В письме были указаны социальные сети адресатов, пожалуйста, попробуйте с ними связаться и выяснить новые почтовые адреса.</div>

                    <div class="form-field-input-2">
                        <label>Социальные сети адресатов:</label>
                        <div class="field-input-wrapper">
                            <div v-for="social in socialList" class="field-input-soc">{{ social }}</div>
                        </div>
                    </div>

                    <div class="new-email-block">
                        <div class="form-field-input-2"
                             :class="{'error-field' : emailIncorrect}"
                        >
                            <label>Введите email</label>
                            <div class="field-input-wrapper">
                                <input v-model="newEmail" type="text" class="field-text" required>
                                <div v-show="emailIncorrect" class="msg-form msg-error-field">
                                    Введите корректный email
                                </div>
                            </div>
                        </div>
                        <div class="button-block">
                            <button @click="sendLetter" class="button button-dark button-close-window" :disabled="isDisabled">Отправить</button>
                            <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SendError3Window",
    props: ["letter", "socialList"],
    data() {
        return {
            newEmail: '',
            emailIncorrect: false,
        }
    },
    computed: {
        correctEmail() {
            if (this.newEmail === '') {
                return true;
            }
            let reg = new RegExp("^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$");
            this.emailIncorrect = !reg.test(this.newEmail);
            return reg.test(this.newEmail);
        },
        isDisabled() {
            return this.newEmail.length === 0 || !this.correctEmail;
        }
    },
    methods: {
        closeWindow() {
            $('.window-client-check-error-3').removeClass('window-open');
            $('body').removeClass('blocked');
            this.newEmail = '';
            this.emailIncorrect = false;
        },
        sendLetter() {
            let emails = [];
            emails.push(this.newEmail);
            this.$emit('resendLetter', this.letter, emails);
            this.closeWindow();
        },
        getRecepients(recepientList) {
            if (recepientList) {
                return recepientList.split(',').join(', ');
            }
            return "";
        }
    }
}
</script>

<style scoped>

</style>